if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  if (!document.getElementById('zk-sticky-atc-style')) {
    var zkStyle = document.createElement('style');
    zkStyle.id = 'zk-sticky-atc-style';
    zkStyle.textContent = '.scroll_top,#ShopifyChat,shopify-chat,inbox-online-store-chat{bottom:88px !important;}@media(min-width:768px){.scroll_top,#ShopifyChat,shopify-chat,inbox-online-store-chat{bottom:96px !important;}}';
    document.head.appendChild(zkStyle);
  }

  // ZK: el "sensor" que oculta la barra sticky ocupa todo el footer desde arriba,
  // por lo que la barra se esconde apenas se asoma el footer. Lo achicamos para que
  // solo se oculte cerca del final real del footer.
  (function () {
    function shrinkFooterSentinel(sentinel) {
      if (sentinel.dataset.zkPatched) return;
      sentinel.dataset.zkPatched = '1';
      sentinel.style.top = 'auto';
      sentinel.style.bottom = '0';
      sentinel.style.height = '120px';
    }
    function trySentinelNow() {
      var footer = document.getElementById('section-footer');
      if (!footer) return false;
      var sentinel = footer.querySelector('div[class*="opacity-0"][class*="w-0.5"]');
      if (!sentinel) return false;
      shrinkFooterSentinel(sentinel);
      return true;
    }
    if (trySentinelNow()) return;
    var observer = new MutationObserver(function () {
      if (trySentinelNow()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  })();

  // ZK: reordena el precio del producto para que quede precio - precio tachado - %OFF
  // en una sola linea, en vez del badge de descuento como bloque aparte arriba.
  // No usamos el selector CSS :has() porque algunos navegadores/webviews de vista previa
  // no lo soportan y el ajuste quedaba sin aplicarse; en su lugar navegamos el DOM
  // por estructura (:not(.hidden) para saltarnos los divs ocultos target-price/target-compare-at-price).
  (function () {
    if (!document.getElementById('zk-price-badge-style')) {
      var zkPriceStyle = document.createElement('style');
      zkPriceStyle.id = 'zk-price-badge-style';
      zkPriceStyle.textContent = '#MainContent .main-product-price > div > div.zk-price-row{display:flex;align-items:baseline;flex-wrap:wrap;gap:8px;}#MainContent .main-product-price .price-sale{order:1;margin-left:0 !important;}#MainContent .main-product-price small.cap{order:2;}#MainContent .main-product-price .discount-badges-wrapper{order:3;margin-top:0 !important;}';
      document.head.appendChild(zkPriceStyle);
    }
    function collapseEmptyAncestors(node) {
      for (var i = 0; i < 5 && node; i++) {
        if (node.children.length === 0 && node.textContent.trim() === '') {
          node.style.setProperty('display', 'none', 'important');
        }
        if (node.id && node.id.indexOf('shopify-section-') === 0) break;
        node = node.parentElement;
      }
    }
    function findPriceRow(main) {
      var priceWrap = main.querySelector('.main-product-price');
      if (!priceWrap) return null;
      var candidates = priceWrap.querySelectorAll(':scope > div > div');
      for (var i = 0; i < candidates.length; i++) {
        if (!candidates[i].classList.contains('hidden') && candidates[i].querySelector('.price-sale')) {
          return candidates[i];
        }
      }
      return null;
    }
    function tryMoveBadge() {
      // ZK: se busca solo dentro de #MainContent porque las tarjetas de "vista rapida"
      // de productos recomendados pueden duplicar estas mismas clases fuera de pantalla.
      var main = document.getElementById('MainContent');
      if (!main) return false;
      var badge = main.querySelector('.discount-badges-wrapper');
      var priceRow = findPriceRow(main);
      if (!badge || !priceRow) return false;
      if (badge.parentElement === priceRow) return true;
      var oldParent = badge.parentElement;
      priceRow.classList.add('zk-price-row');
      priceRow.appendChild(badge);
      collapseEmptyAncestors(oldParent);
      return true;
    }
    if (tryMoveBadge()) return;
    var zkPriceObserver = new MutationObserver(function () {
      if (tryMoveBadge()) zkPriceObserver.disconnect();
    });
    zkPriceObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { zkPriceObserver.disconnect(); }, 15000);
  })();

  // ZK: la galeria principal del producto trae los puntos de paginacion apagados
  // y usa una transicion de fundido (fade) en vez de deslizar. Interceptamos el
  // store xSplide (que arma el carrusel) para forzar puntos + deslizamiento suave
  // solo en la galeria del producto, sin tocar el resto de los carruseles del sitio.
  // Se usa polling en vez de "alpine:init" porque no podemos garantizar el orden
  // de carga entre este script y el que registra el store.
  (function () {
    function tryPatchSplide() {
      if (!window.Alpine || !Alpine.store) return false;
      const store = Alpine.store('xSplide');
      if (!store || store.__zkPatched) return !!store;
      store.__zkPatched = true;
      const originalLoad = store.load.bind(store);
      store.load = function (el, configs) {
        if (el && el.closest && el.closest('.product-media-container')) {
          configs.pagination = true;
          configs.type = 'slide';
          configs.rewind = true;
        }
        return originalLoad(el, configs);
      };
      return true;
    }
    if (tryPatchSplide()) return;
    var zkSplideInterval = setInterval(function () {
      if (tryPatchSplide()) clearInterval(zkSplideInterval);
    }, 20);
    setTimeout(function () { clearInterval(zkSplideInterval); }, 20000);
  })();

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStickyATC', (sectionId, is_combined) => ({
        openDetailOnMobile: false,
        currentAvailableOptions: [],
        options: [],
        init() {
          // ZK: la barra queda anidada dentro de la columna "sticky" del producto,
          // que en algunos layouts crea un contexto de apilamiento (stacking context)
          // y hace que secciones posteriores de la pagina se dibujen por encima suyo
          // aunque tenga position:fixed. La movemos a <body> para que quede al nivel
          // superior del documento y su z-index funcione correctamente.
          if (this.$el.parentElement !== document.body) {
            document.body.appendChild(this.$el);
          }

          if (!is_combined) {
            this.variants = xParseJSON(this.$el.getAttribute('x-variants-data'));
          }

          document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (is_combined) {
              this.renderVariant(e.detail.html);
            } else {
              this.currentAvailableOptions = e.detail.currentAvailableOptions,
              this.options = e.detail.options;
            }

            this.renderProductPrice(e.detail.html);
            this.renderMedia(e.detail.html);
          });
        },
        renderProductPrice(html) {
          const destinations = document.querySelectorAll(`.price-sticky-${sectionId}`);
          destinations.forEach((destination) => {
            const source = html.getElementById('price-sticky-' + sectionId);
            if (source && destination) destination.innerHTML = source.innerHTML;
          })
        },
        renderMedia(html) {
          const destination = document.getElementById('product-image-sticky-' + sectionId);
          const source = html.getElementById('product-image-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        renderVariant(html) {
          const destination = document.getElementById('variant-update-sticky-' + sectionId);
          const source = html.getElementById('variant-update-sticky-' + sectionId);

          if (source && destination) destination.innerHTML = source.innerHTML;
        },
        changeOptionSticky(event) {
          Array.from(event.target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          event.target.selectedOptions[0].setAttribute('selected', 'selected');
          const input = event.target.selectedOptions[0];
          const inputId = input.id;
          const targetUrl = input.dataset.productUrl;
          const variantEl = document.getElementById('variant-update-sticky-' + sectionId);
          document.dispatchEvent(new CustomEvent(`eurus:product-page-variant-select-sticky:updated:${sectionId}`, {
            detail: {
              inputId: inputId,
              targetUrl: targetUrl,
              variantElSticky: variantEl
            }
          }));
        }
      }))
    })
  })
}